/* Fyndmaxa: storleksväljaren i produktkorten på mobil (2026-09-12).

   Markup i snippets/card-product.liquid (.fm-size-wrap), CSS i
   assets/fyndmaxa-card.css. Knappen .fm-size-toggle fäller ut storleksraden
   som en lista; varje rad får saldot i parentes från data-qty på
   <option>-elementen i kortets dolda <select name="id">. Saldot räknas för
   den variant som matchar vald färg + storleken på raden, alltså den som
   faktiskt läggs i varukorgen.

   Lyssnarna sitter på document: facets.js byter ut hela rutnätet vid
   filtrering, och skriptet laddas en gång per sida (defer) oavsett hur många
   sektioner som renderar kort. */
(function () {
  if (window.__fmSizeInit) return;
  window.__fmSizeInit = true;
  var KEYS = ['option1', 'option2', 'option3'];

  function refresh(wrap) {
    var form = wrap.closest('form');
    var sel = form && form.querySelector('select[name=id]');
    if (!sel) return;
    var checked = {};
    form.querySelectorAll('input[type=radio]:checked').forEach(function (r) { checked[r.dataset.position] = r.value; });
    wrap.querySelectorAll('.card-variants--size label').forEach(function (lab) {
      var r = lab.querySelector('input[type=radio]');
      var q = lab.querySelector('[data-fm-size-qty]');
      if (!r || !q) return;
      var want = {};
      KEYS.forEach(function (k) { want[k] = checked[k]; });
      want[r.dataset.position] = r.value;
      var opt = Array.prototype.find.call(sel.options, function (o) {
        return KEYS.every(function (k) { return !want[k] || o.dataset[k] === want[k]; });
      });
      var qty = opt && opt.dataset.qty ? opt.dataset.qty : null;
      q.textContent = qty === null ? '' : '(' + qty + ')';
      lab.classList.toggle('is-selected', r.checked);
    });
    var lbl = wrap.querySelector('[data-fm-size-label]');
    var cur = wrap.querySelector('.card-variants--size input[type=radio]:checked');
    if (lbl && cur) lbl.textContent = lbl.dataset.name + ': ' + cur.value.split('-').pop().trim();
  }

  function close(w) {
    w.classList.remove('is-open');
    var b = w.querySelector('.fm-size-toggle');
    if (b) b.setAttribute('aria-expanded', 'false');
  }

  function closeAll(except) {
    document.querySelectorAll('.fm-size-wrap.is-open').forEach(function (w) { if (w !== except) close(w); });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var t = e.target.closest('.fm-size-toggle');
    if (t) {
      e.preventDefault();
      var w = t.closest('.fm-size-wrap');
      var open = !w.classList.contains('is-open');
      closeAll(w);
      if (open) { refresh(w); w.classList.add('is-open'); t.setAttribute('aria-expanded', 'true'); }
      else { close(w); }
      return;
    }
    if (!e.target.closest('.fm-size-wrap')) closeAll();
  });

  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!r || !r.matches || !r.matches('.card-wrapper input[type=radio]')) return;
    var card = r.closest('.card-wrapper');
    card.querySelectorAll('.fm-size-wrap').forEach(refresh);
    var w = r.closest('.fm-size-wrap');
    if (w) close(w);
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
})();
